'use strict';


var novicell = novicell || {};
var stocks_weights = stocks_weights || null;
var stocks_names = stocks_names || null;
var obligations_weights = obligations_weights || null;
var obligations_names = obligations_names || null;



novicell.productInventoryListGraphs = novicell.productInventoryListGraphs || new function () 
{
    var mainColorRGB='0, 104, 144';
    var arrMainColorOpacities=['1'];
    var objMainColorsRgba={};

    var arrTooltips = ['tt','tt2'];
    this.showTooltip=function(currentValue,left,right,top,bottom,id){
        //show tooltip on hover, centered in donut chart
        let currentTooltipElement = document.getElementById(id);
        var centerX = ((left + right) / 2);
        var centerY = ((top + bottom) / 2);
        var formattedValue = currentValue.toString().replace('.',',');
        
        // add unit (%)
        currentTooltipElement.innerText=currentValue!=''?formattedValue + '%' :'';

        currentTooltipElement.style.left=centerX+'px';
        currentTooltipElement.style.top=centerY+'px';
    };
    this.initDonutChart = function (graphContainer) {
        var self = this;
        
        Vue.component('doughnut', {
            extends: VueChartJs.Doughnut,
            mixins: [VueChartJs.mixins.reactiveProp],
            props:['chartData','options'],
            mounted() {
                this.renderChart(this.chartData, this.options);
            }
        });
        
        // vars for keeping track of what's hovered (it can be legends or donut parts, and keep track of the index)
        var hoveredDatasetIndex = -1;
        var hoveredChartDatasetIndex = -1;
        var chartHover = false;
        var donutEntered = false;

        var vm = new Vue({
            el: graphContainer,
            data: {
                options:{
                    responsive: true, 
                    maintainAspectRatio: false,
                    hover: {
                        onHover: function(e) {
                            // reset hover settings, if you're not hovering over the donut chart itself and the hoveredChartDatasetIndex says no element is hovered
                            if(donutEntered==true){
                                donutEntered=false;
                            }
                            if(!chartHover){
                                if(hoveredChartDatasetIndex==-1){
                                    var tooltipBoxId = this.data.tooltipId;
                                    self.showTooltip('',0,0,0,0,tooltipBoxId);
                                    
                                    var ci = this.chart;
                                    ci.updateHoverStyle(ci.getDatasetMeta(0).data, null, false);
                                    
                                    let correspondingLegends = this.legend.legendItems;
                                    for(var i = 0 ; i < correspondingLegends.length ; i++){
                                        let correspondingLegendOriginalColor = this.chart.data.datasets[0].backgroundColor[i];
                                        correspondingLegends[i].fillStyle = correspondingLegendOriginalColor;
                                    }
                                }
                                hoveredDatasetIndex=-1;
                            }
                        }
                    },
                    legend:{
                        display:false
                    },
                    layout:{
                        padding:{
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    tooltips: {
                        enabled: false,
                        callbacks: {
                            label: function(tooltipItem, data) {
                                donutEntered=true;
                            // show tooltip, if you're not hovering over the donut chart itself
                                hoveredChartDatasetIndex=tooltipItem.index;
                                let currentValue = data.datasets[0].data[tooltipItem.index];
                                var tooltipBoxId = data.tooltipId;
                                self.showTooltip(currentValue,this._chart.chartArea.left,this._chart.chartArea.right,this._chart.chartArea.top,this._chart.chartArea.bottom,tooltipBoxId);
                            }
                        },
                        mode: 'index',
                        // intersect: false, ---- don't add this or hover will be unreliable
                        custom: function(tooltipModel) {
                            if (tooltipModel.body == undefined) {
                                // reset hover setting, if you're not hovering

                                var ci = this._chart.chart;
                                ci.updateHoverStyle(ci.getDatasetMeta(0).data, null, false);
                                
                                let legends = document.getElementsByClassName('product-inventory-list-graphs__list-item');
                                for(var j = 0 ; j < legends.length ; j++){
                                    legends[j].classList.remove('product-inventory-list-graphs__list-item--active');
                                }
                                
                                hoveredDatasetIndex = -1;
                                hoveredChartDatasetIndex=-1;
                                ci.render();
                                var tooltipBoxId = this._chart.data.tooltipId;

                                self.showTooltip('',0,0,0,0,tooltipBoxId);
                                chartHover=false;
                                
                            }else{
                                // hover settings, if you're not hovering over one of the legends
                                let type = 'share';
                                if(this._chart.data.tooltipId == "tooltipBonds"){
                                    type = 'bond';
                                }
                                hoveredDatasetIndex=hoveredChartDatasetIndex;
                                chartHover=true;
                                let legends = document.getElementsByClassName('product-inventory-list-graphs__list-item');
                                for(var k = 0 ; k < legends.length ; k++){
                                    legends[k].classList.remove('product-inventory-list-graphs__list-item--active');
                                }
                                
                                let correspondingLegendHolder =document.querySelectorAll('[data-type='+type+']')[0];//[hoveredDatasetIndex];
                                let correspondingLegend = correspondingLegendHolder.children[hoveredDatasetIndex];
                                correspondingLegend.classList.add('product-inventory-list-graphs__list-item--active');
                                hoveredDatasetIndex=-1;
                            }
                        }
                    }
                },
                shareTooltipId:'tooltipShares',
                bondTooltipId:'tooltipBonds',
                bondDatacollection: {},
                shareDatacollection: {},
                legendary:[]
            },
            mounted() {
                this.fillData('share');
                this.fillData('bond');
            },
            methods: {
                showColor:function(index,type){
                    if(type=='share'){
                        return 'color:'+this._data.shareDatacollection.datasets[0].backgroundColor[index];
                    }
                    else if(type=='bond'){
                        return 'color:'+this._data.bondDatacollection.datasets[0].backgroundColor[index];
                    }
                },
                legendEnter:function(event){
                    if(event.type=='click'){
                        return;
                    }
                    var ul = event.target.parentNode;
                    let typeIndex=0;
                    if(ul.getAttribute('data-type')=='bond')
                    {
                        if(this.$children[1] != undefined){/**if there's only stock or only bonds index 0 won't exist */
                            typeIndex=1;
                        }
                    }

                    var nodes = Array.prototype.slice.call( ul.children );

                    var hoveredDatasetIndex = nodes.indexOf(event.target);
                    var ci = this.$children[typeIndex]._data._chart;
                    var arr = [];
                    arr.push(ci.getDatasetMeta(0).data[hoveredDatasetIndex]);
                    ci.updateHoverStyle(ci.getDatasetMeta(0).data, null, false);
                    ci.updateHoverStyle(arr, null, true);
                    ci.render();
                    let theLegends = ci.legend.legendItems;
                    let legendItem = theLegends[hoveredDatasetIndex];
                    for(let i = 0 ; i < theLegends.length ; i++){
                        theLegends[i].fillStyle = ci.data.datasets[0].backgroundColor[i];
                    }
                    legendItem.fillStyle=objMainColorsRgba.o1;

                    var chartConfig = ci.config;
                    let currentValue = chartConfig.data.datasets[0].data[hoveredDatasetIndex];
                    var tooltipBoxId = ci.data.tooltipId;
                    self.showTooltip(currentValue,ci.chartArea.left,ci.chartArea.right,ci.chartArea.top,ci.chartArea.bottom,tooltipBoxId);
                },
                legendLeave:function(event){
                    if(donutEntered){
                        return;
                    }
                    var ul = event.target.parentNode;
                    let typeIndex=0;
                    if(ul.getAttribute('data-type')=='bond')
                    {
                        if(this.$children[1] != undefined){/**if there's only stock or only bonds index 0 won't exist */
                            typeIndex=1;
                        }
                    }

                    var nodes = Array.prototype.slice.call( ul.children );
                    var hoveredDatasetIndex = nodes.indexOf(event.target);
                    var ci = this.$children[typeIndex]._data._chart;//this.chart;
                    var arr = [];
                    arr.push(ci.getDatasetMeta(0).data[hoveredDatasetIndex]);
                    ci.updateHoverStyle(ci.getDatasetMeta(0).data, null, false);
                    ci.render();
                    var tooltipBoxId = ci.data.tooltipId;
                    self.showTooltip('',0,0,0,0,tooltipBoxId);
                },
                fillData: function(type) {
                    // general datavalues that both donut charts should use
                    const datacollection = [{
                        datasets: [{
                            borderWidth:1,
                            label: [],
                            backgroundColor: [
                                'rgb(102, 102, 102)',
                                'rgb(111, 111, 111)',
                                'rgb(119, 119, 119)',
                                'rgb(128, 128, 128)',
                                'rgb(136, 136, 136)',
                                'rgb(145, 145, 145)',
                                'rgb(153, 153, 153)',
                                'rgb(162, 162, 162)',
                                'rgb(170, 170, 170)',
                                'rgb(179, 179, 179)',
                                'rgb(187, 187, 187)',
                                'rgb(195, 195, 195)',
                                'rgb(204, 204, 204)',
                                'rgb(213, 213, 213)',
                                'rgb(221, 221, 221)',
                                'rgb(230, 230, 230)',
                                'rgb(238, 238, 238)',
                                'rgb(247, 247, 247)'
                            ],
                            hoverBackgroundColor: [
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1,
                                objMainColorsRgba.o1
                            ]
                        }]
                    }];

                    // take the data specific for this donut chart and transform it, since we need values and labels in separate arrays for chartjs
                    var dataValues=[];
                    var dataLabels=[];

                    var newDatacollection = [...datacollection];
                    // fill in with correct data
                    if(type == 'share'){
                        dataValues = stocks_weights;
                        dataLabels = stocks_names;
                        this.shareDatacollection=newDatacollection[0];
                        this.shareDatacollection.labels = dataLabels;
                        this.shareDatacollection.datasets[0].data = dataValues; 
                        this.shareDatacollection.tooltipId = this.shareTooltipId;
                    } else {
                        dataValues = obligations_weights;
                        dataLabels = obligations_names;
                        this.bondDatacollection=newDatacollection[0];
                        this.bondDatacollection.labels = dataLabels;
                        this.bondDatacollection.datasets[0].data = dataValues; 
                        this.bondDatacollection.tooltipId = this.bondTooltipId;
                    }
                }
            }
        }); 
    };
    this.setColors = function(graphContainer){
        // color for graphs = button color

        let testButton = document.createElement('button');
        testButton.id = 'js-testButton';
        testButton.classList.add('theme-button');
        testButton.setAttribute('style','position:fixed;left:-3333px;');
        graphContainer.appendChild(testButton);
        let colorString = getComputedStyle(document.getElementById('js-testButton')).backgroundColor;
        colorString = colorString.replace('rgb(','');
        colorString = colorString.replace(')','');
        mainColorRGB = colorString;
        for(var i = 0 ; i < arrMainColorOpacities.length ; i++){
            objMainColorsRgba['o'+arrMainColorOpacities[i]] = 'rgba('+mainColorRGB+','+arrMainColorOpacities[i]+')';
        }
    };
    this.init = function () {
        
        const graphContainer = document.getElementById('js-product-inventory-list-graphs-container');
        if (graphContainer == null) {
            return;
        }
        this.setColors(graphContainer);
        this.initDonutChart(graphContainer);
        
    };
    
}();
